import React, { FC } from 'react';

import { recordCategoriesSelectors } from '../../../redux/ducks/recordCategories';
import { useRecordDetailsQuery } from '../../../redux/ducks/recordDetails';
import BaseRecords from '../baseRecords';

const SkaterRecords: FC = () => {
    const recordCategory = recordCategoriesSelectors.recordCategoryIdByDescription('skater-records');
    const { data: individualRecords = [], isFetching } = useRecordDetailsQuery(recordCategory, {
        skip: recordCategory === null,
    });
    return <BaseRecords isLoading={isFetching} records={individualRecords} templateKey="RECORDS_INDIVIDUAL" />;
};

export default SkaterRecords;
